<script setup>
import { ref, onMounted } from 'vue'
import SideNav from '../layout/SideNav.vue'

import { useAppointments } from '@store/appointments.js'
const $appointments = useAppointments()

import { useSettings } from '@store/settings.js'
const $settings = useSettings()

import { useCustomizer } from '@store/customizer.js'
const $customizer = useCustomizer()

import { useRoute, useRouter } from 'vue-router'
const route = useRoute()
const router = useRouter()

const props = defineProps({
    sideNav: {
        type: Boolean,
        default: true
    },
    width: {
        type: String,
        default: '800px'
    },
    height: {
        type: String,
        default: '520px'
    },
    // footerHeight: {
    //     type: String,
    //     default: '68px'
    // },
    slotContentClass: {
        type: String,
    },
    rightContentClass: {
        type: String,
    }
})

const state = ref({
    width: props.width, // override when resize
    height: props.height // override when resize
})


const showSideNav = () => {
    if (!props.sideNav || $settings.isWidget) return false

    return 620 < state.value.width.split('px')[0]
}


const prebookBookingWrapperWidth = () => {
    // let prebookBookingWrapper = document.querySelector('[data-prebook-booking]')

    state.value.width = showSideNav() ? props.width : '375px'
    state.value.height = showSideNav() ? props.height : '600px'


    if (route.name == 'confirmation' && !$settings.isWidget) state.value.width = props.width
    // state.value.width = prebookBookingWrapper.clientWidth // override state.width
    // state.value.height = prebookBookingWrapper.clientHeight // override state.height
    // console.log(state.value)
    window.frontendState = state.value
}

onMounted(() => {
    prebookBookingWrapperWidth()

    window.addEventListener('resize', () => prebookBookingWrapperWidth())
    window.addEventListener('click', () => prebookBookingWrapperWidth())

    // $appointments.cookiesAppointment('get')
})

</script>

<style lang="scss" scoped></style>

<template>
    <div :style="`width: ${state.width}; height: ${state.height}; font-family: '${$settings.customizer.design.font_family}'`" class="main-wrapper">
        <!-- side nav -->
        <SideNav v-if="showSideNav()" />

        <!-- right content -->
        <div class="right-content-wrapper" :class="rightContentClass, { 'rounded-r-lg': $customizer.isRounded && !$settings.isRTL, 'rounded-l-lg': (!showSideNav() || $settings.isRTL) && $customizer.isRounded }" :style="`width: ${showSideNav() ? '' : '100%'}`">
            <div class="slot-content-wrapper" :class="slotContentClass" :style="[$slots.footer ? `height:calc(${state.height} - 71px);` : `height:${state.height};`]" style="overflow-y: scroll">
                <slot name="content"></slot>
            </div>
            <div class="slot-footer-wrapper" v-if="$slots.footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>
